// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SnKNE","left":"styles_left__1aSU7","right":"styles_right__2M5TT","alert":"styles_alert__2JDgD"};